<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol sm="4" class="pr-1">
                <input type="text" v-model="searchValue" placeholder="Nama Kantor" class="form-control"/>
            </CCol>
            <CCol sm="3" class="pr-1 pl-1">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleProvinsi()"
                            @blur="toggleCloseVisibleProvinsi()"
                            v-text="selectedItemProvinsi ? selectedItemProvinsi['text'] : ''"
                            v-model="queryProvinsi"
                            @keydown.up="upProvinsi"
                            @keydown.down="downProvinsi"
                            @keydown.enter="selectItemProvinsi"
                            placeholder="Pilih Provinsi"
                    >
                    <div class="popovers" v-show="visibleProvinsi">
                        <div class="options" v-if="matchesProvinsi.length != 0 && queryProvinsi.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesProvinsi"
                                :key="index"
                                :class="{ 'selected': (selectedProvinsi == index)}"
                                @click="itemClickedProvinsi(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesProvinsi.length == 0 && queryProvinsi.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="3" class="pr-1 pl-1">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleKota()"
                            @blur="toggleCloseVisibleKota()"
                            v-text="selectedItemKota ? selectedItemKota['text'] : ''"
                            v-model="queryKota"
                            @keydown.up="upKota"
                            @keydown.down="downKota"
                            @keydown.enter="selectItemKota"
                            placeholder="Pilih Kota"
                    >
                    <div class="popovers" v-show="visibleKota">
                        <div class="options" v-if="matchesKota.length != 0 && queryKota.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesKota"
                                :key="index"
                                :class="{ 'selected': (selectedKota == index)}"
                                @click="itemClickedKota(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesKota.length == 0 && queryKota.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesKota.length == 0 && queryKota.length == 0 && queryProvinsi != 0">
                            Start Typing...
                        </div>
                        <div class="options" v-if="queryProvinsi.length == 0">
                            Pilih Provinsi Dahulu
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol sm="2" class="pl-2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <img class="mr-5 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/>
                <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
</div>
</template>

<script>
import Tables from '../../../component/tables'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        ModelSelect,
        Tables
    },
    data() {
        return {
            titleProvinsi:"Pilih Provinsi",
            selectedItemProvinsi: null,
            selectedProvinsi: 0,
            queryProvinsi: '',
            visibleProvinsi: false,

            titleKota:"Pilih Kota",
            selectedItemKota: null,
            selectedKota: 0,
            queryKota: '',
            visibleKota: false,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Kantor', 'Alamat', 'Kota', 'Provinsi', 'Latitude', 'Longitude', 'Radius'],
            dataTd: [['urlFoto', 'nama'], 'alamat', 'kota', 'provinsi', 'latitude', 'longitude', 'radius'],
            styleTable: ['200px', '160px', '150px', '150px', '120px', '120px', '120px'],
            classReload: 'reloadOff',
            datas: [],
            dataProvinsi: [],
            dataKota: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchValue: '',

            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchValue() {
            this.flagSearch = true
        },
        queryProvinsi() {
            this.getProvince()
            this.dataKota = []
            this.queryKota = ''
            this.flagSearch = true
        },
        queryKota() {
            this.getCity()
            this.flagSearch = true
        }
    },
    computed: {
        matchesProvinsi() {
            if (this.queryProvinsi == '') {
                return [];
            }
            return this.dataProvinsi.filter((item) => item['text'].toLowerCase().includes(this.queryProvinsi.toLowerCase()))
        },
        matchesKota() {
            if (this.queryKota == '') {
                return [];
            }
            return this.dataKota.filter((item) => item['text'].toLowerCase().includes(this.queryKota.toLowerCase()))
        },
    },
    methods: {
        toggleVisibleProvinsi() {
            this.visibleProvinsi = true;
        },
        hideProvinsi() {
            this.visibleProvinsi = false;
        },
        toggleCloseVisibleProvinsi() {
            setTimeout(this.hideProvinsi, 1000);
        },
        itemClickedProvinsi(index) {
            this.selectedProvinsi = index;
            this.selectItemProvinsi();
        },
        selectItemProvinsi() {
            if (!this.matchesProvinsi.length) {
            return;
            }
            this.selectedItemProvinsi = this.matchesProvinsi[this.selectedProvinsi];
            this.queryProvinsi = this.selectedItemProvinsi.text
            this.visibleProvinsi = false;
            if (this.shouldReset) {
            this.queryProvinsi = '';
            this.selectedProvinsi = 0;
            }
        },
        upProvinsi() {
            if (this.selectedProvinsi == 0) {
            return;
            }
            this.selectedProvinsi -= 1;
            this.scrollToItemProvinsi();
        },
        downProvinsi() {
            if (this.selectedProvinsi >= this.matchesProvinsi.length - 1) {
            return;
            }
            this.selectedProvinsi += 1;
            this.scrollToItemProvinsi();
        },
        scrollToItemProvinsi() {
            this.$refs.optionsList.scrollTop = this.selectedProvinsi * this.itemHeight;
        },
        toggleVisibleKota() {
            this.visibleKota = true;
        },
        hideKota() {
            this.visibleKota = false;
        },
        toggleCloseVisibleKota() {
            setTimeout(this.hideKota, 1000);
        },
        itemClickedKota(index) {
            this.selectedKota = index;
            this.selectItemKota();
        },
        selectItemKota() {
            if (!this.matchesKota.length) {
            return;
            }
            this.selectedItemKota = this.matchesKota[this.selectedKota];
            this.queryKota = this.selectedItemKota.text
            this.visibleKota = false;
            if (this.shouldReset) {
            this.queryKota = '';
            this.selectedKota = 0;
            }
        },
        upKota() {
            if (this.selectedKota == 0) {
            return;
            }
            this.selectedKota -= 1;
            this.scrollToItemKota();
        },
        downKota() {
            if (this.selectedKota >= this.matchesKota.length - 1) {
            return;
            }
            this.selectedKota += 1;
            this.scrollToItemKota();
        },
        scrollToItemKota() {
            this.$refs.optionsList.scrollTop = this.selectedKota * this.itemHeight;
        },



        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let provinsi = this.queryProvinsi
            let kota = this.queryKota
            let limit = this.size
            let nama = this.searchValue
            let page = this.page
            let pusat = ''

            let payload = {
                kota: kota,
                limit: limit,
                nama: nama,
                pageIn: page,
                provinsi: provinsi,
                pusat: pusat
            }
            DataApi.post("kantor/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchValue = ''
            this.queryProvinsi = ''
            this.queryKota = ''
            this.flagSearch = true
            this.getData
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
            this.getProvince()
            this.getCity()
        },
        getProvince() {
            let payload = {
                provinsi: this.queryProvinsi
            }
            DataApi.post("kantor/get/provinsi", payload)
            .then(res => {
                this.dataProvinsi = []
                let response = res.data.data
                var i;
                for(i=0;i<response.length;i++) {
                    let values = {
                        value: response[i],
                        text: response[i]
                    }
                    this.dataProvinsi.push(values)
                }
            })
        },
        getCity() {
            if(this.queryProvinsi.length == 0) {
                this.dataKota = []
            } else {
                let payload = {
                    kabkota: this.queryKota,
                    provinsi: this.queryProvinsi
                }
                DataApi.post("kantor/get/kabkota", payload)
                .then(res => {
                    this.dataKota = []
                    let response = res.data.data
                    var i;
                    for(i=0;i<response.length;i++) {
                        let values = {
                            value: response[i].kabkota,
                            text: response[i].kabkota
                        }
                        this.dataKota.push(values)
                    }
                })
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getProvince()
        this.getCity()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    float: left;
    width: 160px;
    margin-left: 4px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: left;
    width: 160px;
    margin-left: 4px;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
::v-deep .ui.search.dropdown .text {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>